"use strict";
exports.__esModule = true;
var angular = require("angular");
var ZONE_COLORS = {
    'DISCOVERY': '#ffcce469',
    'SPECIFY': '#ffffb3F0',
    'NAVIGATE': '#a0c5f899',
    'MANAGE': '#b3ffe4A0'
};
function makeIssueZoneAndColor(ignorance, impact) {
    var issueColor = ZONE_COLORS.MANAGE;
    var issueZone = 'Manage';
    if (ignorance >= 5 && impact >= 5) {
        issueColor = ZONE_COLORS.DISCOVERY;
        issueZone = 'Discovery';
    }
    else if (ignorance >= 5 && impact < 5) {
        issueColor = ZONE_COLORS.SPECIFY;
        issueZone = 'Specify';
    }
    else if (ignorance < 5 && impact >= 5) {
        issueColor = ZONE_COLORS.NAVIGATE;
        issueZone = 'Navigate';
    }
    return { 'issueZone': issueZone, 'issueColor': issueColor };
}
function formatIssueData(item, isQualitative) {
    var impactToBeUsed = isQualitative ? item.impact : item.calcImpact;
    var score = item.ignorance * impactToBeUsed;
    var experimentData = item.experimentData.length > 0 ? item.experimentData[0] : {};
    item['score'] = score;
    item['cost'] = 'cost' in experimentData ? experimentData.cost : 0;
    item['resourceFte'] = 'resourceFte' in experimentData ? experimentData.resourceFte : 0;
    item['totalCost'] = 'totalCost' in experimentData ? experimentData.totalCost : 0;
    item['duration'] = 'duration' in experimentData ? experimentData.duration : 0;
    item['expName'] = 'name' in experimentData ? experimentData.name : '';
    item['expId'] = '_id' in experimentData ? experimentData._id : '';
    item['issueDescription'] = 'issueDescription' in item ? item.issueDescription : undefined;
    item['needToLearn'] = 'needToLearn' in experimentData ? experimentData.needToLearn : '';
    item['goingToLearn'] = 'goingToLearn' in experimentData ? experimentData.goingToLearn : '';
    item['toMeasure'] = 'toMeasure' in experimentData ? experimentData.toMeasure : '';
    item['successCriteria'] = 'successCriteria' in experimentData ? experimentData.successCriteria : '';
    item['inIterationPlan'] = 'inIterationPlan' in item ? item.inIterationPlan : false;
    item['startDate'] = ('startDate' in item && item.startDate) ? new Date(item.startDate) : undefined;
    return item;
}
var LearningPlanComponent = /** @class */ (function () {
    function LearningPlanComponent($rootScope, $scope, $timeout) {
        this.disableEdit = false;
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.$scope = $scope;
        ctrl.$timeout = $timeout;
        ctrl.$rootScope = $rootScope;
        ctrl.dashboardExpPriority = false;
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        ctrl.showGenerateBtn = false;
        $scope.$on('command:LP_MILESTONES', function (event, args) {
            $scope.$emit('workbench:loading', { 'load': false });
            ctrl.initLp(event, args, 'Milestones');
            ctrl.$scope.$apply();
        });
        $scope.$on('command:LP_RESULTS', function (event, args) {
            $scope.$emit('workbench:loading', { 'load': false });
            ctrl.initLp(event, args, 'Results');
            // ctrl.initLpResults(event, args);
            ctrl.$scope.$apply();
        });
        $scope.$on('command:LP_PLAN_SUMMARY', function (event, args) {
            $scope.$emit('workbench:loading', { 'load': false });
            ctrl.initLp(event, args, 'Plan Summary');
            ctrl.$scope.$apply();
        });
        $scope.$on('command:LP_EXPERIMENTS', function (event, args) {
            $scope.$emit('workbench:loading', { 'load': false });
            ctrl.initLp(event, args, 'Experiments');
            ctrl.$scope.$apply();
        });
        $timeout();
        $('select option')
            .filter(function () {
            return !this.value || $.trim(this.value).length == 0 || $.trim(this.text).length == 0;
        })
            .remove();
    }
    LearningPlanComponent.prototype.setGlobalDirty = function () {
        var ctrl = this;
        ctrl.$timeout(function () {
            ctrl.$rootScope.smartorgDirty = ctrl.isDirty;
        }, 0);
    };
    LearningPlanComponent.prototype.initLp = function (event, args, title) {
        var ctrl = this;
        ctrl.disableEdit = (args.node.permissions == 'r');
        ctrl.title = title;
        ctrl.nodeName = args.node.name;
        ctrl.node = args.node;
        ctrl.isQualitative = false;
        if ('inavImpactType' in ctrl.node) {
            ctrl.isQualitative = ctrl.node['inavImpactType'] == 'Qualitative';
        }
        var experimentsData = [];
        args.issueData.map(function (i) {
            var experiment = i.experimentData[0];
            if (title == 'Experiments' && experiment &&
                (experiment.status == "Backlog" || experiment.status == "In Plan" || experiment.status == "Completed")) {
                experimentsData.push(i);
            }
            else if (experiment && experiment.status == "In Plan") {
                experimentsData.push(i);
            }
        });
        ctrl.issueData = experimentsData.map(function (item) { return formatIssueData(item, ctrl.isQualitative); });
        ctrl.menu = [];
        ctrl.calcDurationAndMilestoneCheckpoint();
        if (title != 'Plan Summary') {
            ctrl.getLearningPlanData();
        }
    };
    LearningPlanComponent.prototype.getLearningPlanData = function () {
        var ctrl = this;
        ctrl.smartorg.getInavLearningPlanData(ctrl.node['_id']).then(function (data) {
            ctrl.planDescription = data['description'];
            ctrl.planResult = data['result'];
            ctrl.planRecommendation = data['recommendation'];
            ctrl.actionMilestoneCheckpoint = new Date(data['actionMilestoneCheckpoint']);
            ctrl.actionBudget = parseFloat(data['actionBudget'].toFixed(2));
            ctrl.$scope.$apply();
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', 'Cannot get Learning Plan data' + err.message);
        });
    };
    LearningPlanComponent.prototype.calcDurationAndMilestoneCheckpoint = function () {
        var ctrl = this;
        ctrl.budget = 0;
        ctrl.learningPlanData = [];
        ctrl.issueData.forEach(function (issue) {
            if (issue.inIterationPlan) {
                ctrl.budget += issue.totalCost;
                issue.endDate = issue.startDate ? new Date(issue.startDate.getTime() + (issue.duration * 7 * 24 * 60 * 60 * 1000)) : undefined;
                ctrl.learningPlanData.push(issue);
            }
        });
        ctrl.budget = parseFloat(ctrl.budget.toFixed(2));
        //let descSortByStartDate = angular.copy(ctrl.learningPlanData).sort((a, b) => b.startDate - a.startDate);
        var ascSortByStartDate = angular.copy(ctrl.learningPlanData).sort(function (a, b) { return a.startDate - b.startDate; });
        var descSortByEndDate = angular.copy(ctrl.learningPlanData).sort(function (a, b) { return b.endDate - a.endDate; });
        ctrl.milestoneCheckpoint = descSortByEndDate[0].endDate ? descSortByEndDate[0].endDate.toLocaleString().split(',')[0] : '-';
        var diffInTime = descSortByEndDate[0].endDate - ascSortByStartDate[0].startDate;
        ctrl.durationInWeeks = (diffInTime / (1000 * 3600 * 24 * 7)).toFixed(1);
    };
    LearningPlanComponent.prototype.saveIssueData = function (updateDurationAndMilestone) {
        if (updateDurationAndMilestone === void 0) { updateDurationAndMilestone = false; }
        var ctrl = this;
        var selectedIssue = ctrl.issueData[ctrl.selectedIndex];
        var impactToBeUsed = ctrl.isQualitative ? selectedIssue.impact : selectedIssue.calcImpact;
        var issueToBeSaved = {
            '_id': selectedIssue._id,
            'name': selectedIssue.name,
            'ignorance': selectedIssue.ignorance,
            'impact': selectedIssue.impact,
            'calcImpact': selectedIssue.calcImpact,
            'score': selectedIssue.ignorance * impactToBeUsed,
            'type': selectedIssue.type,
            'impactMappingList': selectedIssue.impactMappingList,
            'updatedAt': selectedIssue.updatedAt,
            'isPotentialShowStopper': selectedIssue.isPotentialShowStopper,
            'abilityToLaunch': selectedIssue.abilityToLaunch,
            'inIterationPlan': selectedIssue.inIterationPlan,
            'startDate': selectedIssue.startDate,
            'endDate': selectedIssue.endDate,
            'experiments': selectedIssue.experiments
        };
        ctrl.smartorg.saveInavIssueData(issueToBeSaved, ctrl.node['_id']).then(function (res) {
            if (res) {
                ctrl.issueData[ctrl.selectedIndex] = formatIssueData(ctrl.issueData[ctrl.selectedIndex], ctrl.isQualitative);
                ctrl.isDirty = false;
                ctrl.setGlobalDirty();
                ctrl.origCurrExperiment = angular.copy(ctrl.currExperiment);
                ctrl.showAlert('success', 'Saved!', 'Details saved for issue "' +
                    ctrl.issueData[ctrl.selectedIndex]['name'] + '"');
                if (updateDurationAndMilestone) {
                    ctrl.calcDurationAndMilestoneCheckpoint();
                }
                ctrl.$scope.$apply();
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    LearningPlanComponent.prototype.changeStartDate = function (startDate, issueId) {
        var ctrl = this;
        ctrl.issueData.forEach(function (issue, idx) {
            if (issue._id == issueId) {
                ctrl.selectedIndex = idx;
                issue.startDate = startDate.toString();
                ctrl.saveIssueData(true);
            }
        });
    };
    LearningPlanComponent.prototype.saveLearningPlanData = function () {
        var ctrl = this;
        ctrl.smartorg.saveInavLearningPlanData(ctrl.node['_id'], ctrl.planDescription, ctrl.planResult, ctrl.planRecommendation, ctrl.actionMilestoneCheckpoint.toString(), ctrl.actionBudget).then(function (res) {
            if (res) {
                ctrl.showAlert('success', 'Success!', 'Details are saved.');
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    LearningPlanComponent.prototype.milestoneVariance = function () {
        var ctrl = this;
        if (ctrl.milestoneCheckpoint && ctrl.actionMilestoneCheckpoint) {
            var diffInTime = angular.copy(new Date(ctrl.milestoneCheckpoint)) - ctrl.actionMilestoneCheckpoint;
            return (diffInTime / (1000 * 3600 * 24 * 7)).toFixed(1) + ' weeks';
        }
        return 'NA';
    };
    return LearningPlanComponent;
}());
angular.module('smartorg.r6.acts.learningPlan', []).component('learningPlan', {
    template: require('./learning-plan.component.html'),
    controller: LearningPlanComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
});
module.exports = 'smartorg.r6.acts.learningPlan';
//# sourceMappingURL=learning-plan.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/learning-plan/learning-plan.component.js